import mrpStyles from './../mrp.json'

const primaryWhiteLink = {
  color: mrpStyles.colors.PrimaryWhite,
  borderBottom: `1px solid ${mrpStyles.colors.PrimaryWhite}`
}

export default {
  name: 'B6',
  type: 'Heading',
  default: {
    color: mrpStyles.colors.SecondaryGreyMetal,
    borderBottom: `1px solid ${mrpStyles.colors.SecondaryGreyMetal}`
  },
  hover: {
    color: mrpStyles.colors.SecondaryGreySky,
    borderBottom: `1px solid ${mrpStyles.colors.SecondaryGreySky}`
  },
  inverseDefault: primaryWhiteLink,
  inverseHover: primaryWhiteLink
}
